<div style="height:52vh;     
display: flex;
flex-direction: column;
justify-content: space-evenly; background-color: #2A4152;">
    <section class="section section--primary">
        <div class="shell shell--size-4">
            <div class="row" style="align-items: center;">
                <div class="col">
                    <div class="row mr-3">
                        <div class="col">
                            <a href="https://cosmic-algorithm.ie/etoro" style="text-decoration: none;">
                                <div>
                                    <div style="text-align: center">
                                        <img src="../../assets/img/IBKR-Mobile.png" style="max-width: 75%;"/>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row ml-3">
                        <div class="col">
                            <a href="https://backseat-trader.com/etoro" style="text-decoration: none;">
                                <div>
                                    <div style="text-align: center; margin-top:20%; margin-bottom:20%">
                                        <img src="../../assets/img/Etoro_logo.svg.png" style="max-width: 75%;"/>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>